// modules
import { get } from 'lodash'
import { handleActions } from 'redux-actions'
import { createSelector } from 'reselect'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

// utils
import {
  setIsCommunicationShowAll,
  setPatientUuidChat,
  setUnreadMessagesCount
} from 'src/store/modules/actionCreators'

// constants
import {
  CHAT_MESSAGE,
  GET_CHAT_IMAGE,
  MODULE_LIST,
  POST_CHAT_IMAGE
} from 'src/constants'
import api from 'src/services/@core/API'

/* --------- reducer --------- */
const initialState = {
  unreadMessagesCount: '0',
  patientUuidChat: null,
  isCommunicationShowAll: false
}

export default handleActions(
  {
    [setPatientUuidChat](state, { payload: patientUuidChat }) {
      return {
        ...state,
        patientUuidChat
      }
    },

    [setUnreadMessagesCount](state, { payload: unreadMessagesCount }) {
      return {
        ...state,
        unreadMessagesCount
      }
    },
    [setIsCommunicationShowAll](state, { payload: isCommunicationShowAll }) {
      return {
        ...state,
        isCommunicationShowAll
      }
    }
  },
  initialState
)

/* --------- thunks --------- */
export const getChat = (params) => () => {
  try {
    return api.getChat(params)
  } catch (err) {
    catchError(err)

    throw err
  }
}
export const getChats = (query) => () => {
  try {
    return api.getChats(query)
  } catch (err) {
    catchError(err)

    throw err
  }
}

export const getChatMessage = (params) => () => api.getChatMessage(params)
export const getChatMessages = (params, query) => () => {
  try {
    return api.getChatMessages(params, query)
  } catch (err) {
    catchError(err)

    return []
  }
}

export const getUnreadChatMessages = () => async (dispatch) => {
  try {
    const { count } = await api.getUnreadChatsAmount()

    dispatch(setUnreadMessagesCount(count))
  } catch (err) {
    catchError(err)
  }
}

export const postChatMessage =
  (params, payload, headers) => async (dispatch) => {
    try {
      const message = await api.postChatMessage(params, payload, headers)
      return message
    } catch (err) {
      catchError(err)
      return null
    }
  }

export const postChatMessageAcknowledgement = (params) => async (dispatch) => {
  await api.postChatMessageAcknowledgement(params)
}

export const deleteChatMessage =
  (params = {}, customHeaders = {}) =>
  async () => {
    try {
      await httpClient.request({
        method: 'delete',
        url: {
          pathname: CHAT_MESSAGE,
          params
        },
        customHeaders
      })
    } catch (err) {
      if (err.status === 404) return

      catchError(err)
    }
  }

export const getChatImage =
  (config = {}) =>
  async () => {
    const { params = {} } = config

    try {
      const { data } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_CHAT_IMAGE,
          params
        },
        isDownload: true
      })

      return data
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const saveChatImage =
  (config = {}) =>
  async () => {
    const { params = {}, data = {} } = config

    try {
      const response = await httpClient.upload({
        url: {
          pathname: POST_CHAT_IMAGE,
          params
        },
        data
      })

      return get(response, ['data'], null)
    } catch (err) {
      catchError(err)

      return null
    }
  }

/* --------- selectors --------- */
export const chatsSelector = (state) => state.chats

export const isCommunicationShowAll$ = createSelector(
  chatsSelector,
  ({ isCommunicationShowAll }) => isCommunicationShowAll
)
export const patientUuidChat$ = createSelector(
  chatsSelector,
  ({ patientUuidChat = null }) => patientUuidChat
)

export const unreadMessagesCountSelector = createSelector(
  chatsSelector,
  ({ unreadMessagesCount = null }) => unreadMessagesCount
)

const profile = (state) => state.user.profile
export const chatEnable$ = createSelector(profile, (profile) => {
  const licenseModule = get(profile, ['licenseModule'], [])
  const chatEnable = !!licenseModule.filter(
    (item) => item.name === MODULE_LIST.chat
  ).length

  return chatEnable
})
